<!--
 * @Date: 2022-06-14 11:36:27
 * @LastEditors: lizixuan 240514049@qq.com
 * @LastEditTime: 2022-08-01 15:56:13
 * @FilePath: \hw_game_mp_gamebrain_data\frontend\src\components\V1\GroupEditDialog.vue
 * @Description: 
-->
<template>
  <a-modal :visible="showDialog" :mask="true" :maskClosable="false" title="编辑" @ok="handleOk" @cancel="handleCancel()">
   <a-form layout="vertical">
     <a-form-item label="分组名">
       <a-input v-model="groupInfo.real_name" placeholder="分组名" />
     </a-form-item>
     <a-form-item label="标识">
       <a-input v-model="groupInfo.name" placeholder="标识" />
     </a-form-item>
     <a-form-item label="排序">
       <a-input v-model="groupInfo.sort" placeholder="排序" />
     </a-form-item>
     <a-form-item label="父级菜单">
        <a-tree-select
          v-model="groupInfo.parent"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="groupList"
          allow-clear
          placeholder="父级菜单"
          treeNodeFilterProp ="real_name"
          show-search
          tree-default-expand-all
          :replaceFields="{children:'children', title:'real_name', key:'id',value:'id' }"
        >
        </a-tree-select>
     </a-form-item>
     <a-form-item label="状态">
       <a-radio-group v-model="groupInfo.status">
          <a-radio-button value="1">
            启用
          </a-radio-button>
          <a-radio-button value="2">
            禁用
          </a-radio-button>
        </a-radio-group>
     </a-form-item>
    
     
   </a-form>
  </a-modal>
</template>
<script>
import {GroupSave} from "../../api/v1/group_api";

export default {
  name: "GroupEditDialog",
  props:['groupInfo','showDialog','userList','groupList'],
  data(){
    return {
    }
  },
  methods:{
    handleOk(){
      if (!this.groupInfo.name) {
          this.$message.error('请填写分组标识')
          return 
      }
      if (!this.groupInfo.real_name) {
          this.$message.error('请填写分组名称')
          return 
      }
      let data = {
        "id":this.groupInfo.id,
        "name":this.groupInfo.name,
        "real_name":this.groupInfo.real_name,
        "sort":this.groupInfo.sort,
        "parent":this.groupInfo.parent,
        "status":this.groupInfo.status,
      }

      GroupSave(data).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel(){
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/V1/GroupEditDialog.vue